import { createContext } from "react";
import { useState } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import claimService from "../services/ClaimService";
import contractService from "../services/ContractService";
import debtorService from "../services/DebtorService";
import dmsService from "../services/DMSService";
import { getItemWithExpiry, setItemWithExpiry } from "../utils/sessionStorageWithExpiry";
import { useAuth } from "./AuthContext";
const DMSContext = createContext();

export const useDMSContext = () => useContext(DMSContext);

export const DMSProvider = ({ children }) => {
  const [debtors, setDebtors] = useState(getItemWithExpiry("debtors") || []);
  const [contracts, setContracts] = useState(getItemWithExpiry("contracts") || []);
  const [claims, setClaims] = useState(getItemWithExpiry("claims") || []);
  const [statistics, setStatistics] = useState(getItemWithExpiry("statistics") || []);
  const [settings, setSettings] = useState(getItemWithExpiry("settings") || []);
  const { authUser } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const fetchStatistics = async () => {
    try {
      const data = await dmsService.getStatistics();
      setStatistics(data);
      setItemWithExpiry("statistics", data);
    } catch (error) {}
  };

  const fetchDebtors = async () => {
    try {
      const data = await debtorService.getDebtorsByUser();
      setDebtors(data);
      setItemWithExpiry("debtors", data);
    } catch (error) {}
  };

  const fetchContracts = async () => {
    try {
      const data = await contractService.getContractsByUser();
      setContracts(data);
      setItemWithExpiry("contracts", data);
    } catch (error) {}
  };

  const fetchClaims = async () => {
    try {
      const data = await claimService.getClaimsByUser();
      setClaims(data);
      setItemWithExpiry("claims", data);
    } catch (error) {}
  };

  const fetchSettings = async () => {
    try{
      const data = await dmsService.getSettings();

      const transformedData = {
        ...data,
        rateValue: data.rateValue * 100,
      };
  
      setSettings(transformedData);
      setItemWithExpiry("settings", transformedData);
    }catch(error) {}
  }

  useEffect(() => {
    if (!getItemWithExpiry("debtors") && authUser) fetchDebtors();
    if (!getItemWithExpiry("contracts") && authUser) fetchContracts();
    if (!getItemWithExpiry("claims") && authUser) fetchClaims();
    if (!getItemWithExpiry("statistics") && authUser) fetchStatistics();
    if (!getItemWithExpiry("settings") && authUser) fetchSettings();
  }, [authUser]);

  useEffect(() => {
    refetchStatistics();
  }, [debtors,contracts]);

  const refetchDebtors = () => {
    sessionStorage.removeItem("debtors");
    fetchDebtors();
  };
  const refetchContracts = () => {
    sessionStorage.removeItem("contracts");
    fetchContracts();
  };
  const refetchClaims = () => {
    sessionStorage.removeItem("claims");
    fetchClaims();
  };
  const refetchStatistics = () => {
    sessionStorage.removeItem("statistics");
    fetchStatistics();
  };
  const refetchSettings = () => {
    sessionStorage.removeItem("settings");
    fetchSettings();
  }
  const getContractById = (id) => contracts.find(c => c.id == id);
  const getDebtorById = (id) => debtors.find(c => c.id == id);
  const getContractsByDebtor = (debtorId) =>
  contracts.filter(contract => String(contract.debtorId) === String(debtorId));


  return (
    <DMSContext.Provider value={{ debtors, setDebtors, refetchDebtors, contracts, setContracts, refetchContracts, claims, setClaims,
     refetchClaims, statistics, setStatistics, refetchStatistics, toggleSidebar, sidebarOpen, settings, setSettings, refetchSettings, getContractById, getDebtorById, getContractsByDebtor }}>
      {children}
    </DMSContext.Provider>
  );
};